import React from 'react';
import { CompetencyGrid } from '../components/CompetencyGrid';
import { Search, ShieldCheck, Zap } from 'lucide-react';
import { PageWrapper, SectionWrapper } from '../components/MotionWrappers';
export function Capabilities() {
  return <PageWrapper data-id="element-380">
      <div className="bg-white" data-id="element-381">
        <div className="bg-federal-blue py-20 text-white" data-id="element-382">
          <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-383">
            <h1 className="text-4xl md:text-5xl font-black mb-6" data-id="element-384">
              Technical Capabilities
            </h1>
            <p className="text-white/70 max-w-3xl text-xl leading-relaxed" data-id="element-385">
              Engineering resilient infrastructure, autonomous compliance
              software, and sustainable energy solutions for the modern public
              sector landscape.
            </p>
          </div>
        </div>

        <SectionWrapper data-id="element-386">
          <CompetencyGrid data-id="element-387" />
        </SectionWrapper>

        <section className="py-20 bg-white border-t border-slate-100" data-id="element-388">
          <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-389">
            <SectionWrapper data-id="element-390">
              <h2 className="text-2xl font-black text-federal-blue mb-12 uppercase tracking-widest text-center" data-id="element-391">
                Our Delivery Methodology
              </h2>
            </SectionWrapper>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-392">
              {[{
              icon: Search,
              title: '01. Discovery & Continuous Audit',
              desc: 'Comprehensive assessment of legacy infrastructure, automated directory crawls for unremediated assets, and environmental site footprints.'
            }, {
              icon: ShieldCheck,
              title: '02. Secure USWDS & Zero-Trust Engineering',
              desc: 'Agile development frameworks focused on NIST 800-53 standards, utilizing USWDS components and secure API configurations.'
            }, {
              icon: Zap,
              title: '03. Rapid Deployment & Field Execution',
              desc: 'Phased software releases with continuous monitoring alongside specialized field engineering for immediate structural and environmental remediation.'
            }].map((step, i) => <SectionWrapper key={i} delay={i * 0.1} data-id="element-393">
                  <div className="p-8 border border-slate-200 rounded-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 bg-slate-50/50 h-full" data-id="element-394">
                    <step.icon className="w-10 h-10 text-muted-gold mb-6" data-id="element-395" />
                    <h3 className="text-xl font-bold text-federal-blue mb-3" data-id="element-396">
                      {step.title}
                    </h3>
                    <p className="text-tech-slate text-sm leading-relaxed opacity-80" data-id="element-397">
                      {step.desc}
                    </p>
                  </div>
                </SectionWrapper>)}
            </div>
          </div>
        </section>

        <SectionWrapper data-id="element-398">
          <section className="py-20 bg-slate-50" data-id="element-399">
            <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-400">
              <div className="bg-federal-blue p-12 md:p-16 rounded-sm text-white flex flex-col md:flex-row items-center justify-between gap-8 shadow-2xl" data-id="element-401">
                <div className="max-w-xl text-center md:text-left" data-id="element-402">
                  <h2 className="text-3xl font-black mb-4" data-id="element-403">
                    Ready for a Technical Assessment?
                  </h2>
                  <p className="text-white/70 text-lg" data-id="element-404">
                    Our engineers and compliance specialists are ready to review
                    your agency's specific requirements and provide a detailed
                    procurement roadmap.
                  </p>
                </div>
                <button className="bg-muted-gold hover:bg-gold-hover text-white px-10 py-5 font-bold rounded-sm whitespace-nowrap transition-all shadow-lg active:scale-95" data-id="element-405">
                  Schedule Consultation
                </button>
              </div>
            </div>
          </section>
        </SectionWrapper>
      </div>
    </PageWrapper>;
}